import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch } from "../../app/hooks";
import { Anchor, IDrawerState, opened } from "./drawerSlice";
import { FiEdit } from "react-icons/fi";

interface EditButtonType {
  ID: number;
  drawerName: string;
  anchor?: Anchor;
  label?: string;
  size?: "large" | "small" | "medium";
}

const ButtonEdit: React.FC<EditButtonType> = (props) => {
  const dispatch = useAppDispatch();

  const handleEdit = (ev: React.MouseEvent) => {
    ev.stopPropagation();
    const drawerOptions: IDrawerState = {
      open: true,
      anchor: props?.anchor || "right",
      name: props?.drawerName,
      drawerWidth: 400,
      data: props?.ID,
      label: props?.label,
    };
    dispatch(opened(drawerOptions));
  };
  return props?.label ? (
    <div className="fw-600" onClick={handleEdit}>
      {props.label}
    </div>
  ) : (
    <Button
      type="button"
      fillMode="flat"
      themeColor="primary"
      size={props?.size || "small"}
      onClick={handleEdit}
      style={{ width: 35, height: 35, position: "relative" }}
    >
      <FiEdit style={{ fontSize: "20px" }} className="absolute-position" />
    </Button>
  );
};

export default ButtonEdit;
